<template>
  <minimal-layout>
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">Login</p>
      </header>
      <div class="card-content">
        <form @submit.prevent="login(user)">
          <b-field>
            <b-input
              v-model="user.username"
              size="is-medium"
              placeholder="Nome utente"
              icon-pack="fas"
              icon="user"
              required
            />
          </b-field>
          <b-field>
            <b-input
              v-model="user.password"
              type="password"
              size="is-medium"
              placeholder="Password"
              icon-pack="fas"
              icon="lock"
              required
              password-reveal
            />
          </b-field>
          <b-field>
            <button class="button is-medium is-primary">Login</button>
          </b-field>
        </form>
      </div>
    </div>
  </minimal-layout>
</template>

<script>
import MinimalLayout from "@/layouts/Minimal.vue"

import { call } from "vuex-pathify"

export default {
  name: "LoginIndex",
  components: {
    MinimalLayout
  },
  data() {
    return {
      user: {
        username: null,
        password: null
      },
      errors: {
        username: null,
        password: null,
        nonField: null
      }
    }
  },
  methods: {
    login: call("auth/login")
  }
}
</script>
